<template>
  <div id="user-list">
    <filas-add-new
      v-model="isAddNewFilasSidebarActive"
      @refetch-data="getEstatiscasFilas"
    />

    <contadores
      :pendentes="qtdFilas.pendentes"
      :ativas="qtdFilas.ativas"
      :inativas="qtdFilas.inativas"
      :filtros="filtros"
      @alterarFiltro="atualizarFiltro"
    />

    <!-- list filters -->
    <v-card>
      <!-- <v-card-title> Filtrar </v-card-title>
      <v-row class="px-2 ma-0">
        role filter
        <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model.trim="filtros"
            placeholder="Selecionar por Status"
            :items="opcoes"
            item-text="title"
            item-value="value"
            outlined
            dense
            clearable
            hide-details
            @change="getEstatiscasFilas"
          ></v-select>
        </v-col>
      </v-row>

      <v-divider class="mt-4"></v-divider> -->

      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          dense
          outlined
          placeholder="Pesquisar"
          hide-details
          class="user-search me-3 mb-4 mr-5"
          @keyup="getEstatiscasFilas"
        />

        <v-select
          v-model="tiposDeCanaisSelecionados"
          dense
          outlined
          placeholder="Canal"
          multiple
          clearable
          hide-details
          item-text="nome"
          item-value="id"
          no-data-text="Nenhum canal disponível"
          class="user-search me-3 mb-4 ml-5"
          :items="tiposDeCanais"
          @change="getEstatiscasFilas"
        />

        <v-spacer></v-spacer>

        <div class="d-flex align-center flex-wrap">
          <v-btn
            v-if="!acessoPost"
            color="success"
            disabled
            class="mb-4 px-4"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar Filas</span>
          </v-btn>

          <v-btn
            v-else
            color="success"
            class="mb-4 px-4"
            @click.stop="isAddNewFilasSidebarActive = !isAddNewFilasSidebarActive"
          >
            <v-icon
              left
              size="25"
              class="mr-1"
            >
              {{ icons.mdiPlus }}
            </v-icon>
            <span>Criar Filas</span>
          </v-btn>
        </div>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <table-filas
          :items="filas"
          :headers="headers"
          :acesso-disable="acessoDisable"
          @confirmar-inativacao="getEstatiscasFilas"
        />
      </v-col>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from '@/views/fila/Contador.vue'
import FilasAddNew from './FilasListAddNew.vue'
import TableFilas from '@/components/tables/TableFilas.vue'
import FilaService from '@/services/modules/FilaService'
import CanalService from '@/services/modules/CanalService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    TableFilas,
    Contadores,
    FilasAddNew,
  },

  setup() {
    const isAddNewFilasSidebarActive = ref(false)

    const { funcionalidades } = storeToRefs(useAuthStore())

    const filas = ref([])
    const loading = ref(true)
    const search = ref('')
    const filtros = ref('')
    const qtdItems = ref(0)
    const qtdFilas = ref({
      total: 0,
      ativas: 0,
      inativas: 0,
      pendentes: 0,
    })

    const idPost = 1096
    const idDisable = 2008
    const acessoPost = ref(true)
    const acessoDisable = ref(true)
    const tiposDeCanais = ref([])
    const tiposDeCanaisSelecionados = ref([])

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'statusNome' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]
    const opcoes = [
      { title: 'Inativas', value: 'Inativa' },
      { title: 'Ativas', value: 'Ativa' },
      { title: 'Pendentes', value: 'Pendente' },
      { title: 'Todas', value: '' },
    ]

    function permissoes() {
      if (!funcionalidades.value.includes(idPost)) {
        acessoPost.value = false
      }
      if (!funcionalidades.value.includes(idDisable)) {
        acessoDisable.value = false
      }
    }

    async function getFilas(itensPorPagina) {
      qtdItems.value = itensPorPagina

      try {
        filas.value = await FilaService.get(itensPorPagina, tiposDeCanaisSelecionados.value, null, null, search.value)

        if (filtros.value) {
          filas.value = filas.value.filter(
            fila => fila.statusNome === filtros.value || fila.statusNome.toString() === filtros.value,
          )
        }
        filas.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))

        setTimeout(() => {
          loading.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    async function getEstatiscasFilas() {
      const data = await FilaService.getEstatisticas()

      qtdFilas.value = {
        total: data.total,
        ativas: data.ativas,
        inativas: data.inativas,
        pendentes: data.pendentes,
      }
      getFilas(qtdFilas.value.total)
    }

    function atualizarFiltro(item) {
      filtros.value = item
      getFilas(qtdItems.value)
    }

    async function getTiposDeCanais() {
      tiposDeCanais.value = await CanalService.getTiposDeCanais()
    }

    onMounted(() => {
      getEstatiscasFilas()
      getTiposDeCanais()
      // permissoes()
    })

    return {
      isAddNewFilasSidebarActive,
      filas,
      loading,
      search,
      filtros,
      qtdItems,
      qtdFilas,
      acessoPost,
      acessoDisable,
      tiposDeCanais,
      tiposDeCanaisSelecionados,
      headers,
      opcoes,
      getEstatiscasFilas,
      atualizarFiltro,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>
